import { CommonModule } from "@angular/common";
import { Component } from "@angular/core";
import { MatDialogModule } from "@angular/material/dialog";
import { MatTabsModule } from "@angular/material/tabs";
import { ActivatedRoute, Router, RouterModule } from "@angular/router";
import { firstValueFrom } from "rxjs";
import { CorpPayorClient } from "src/app/common/services/corp-payor.client";
import { PayorStore } from "../payor-store.service";
@Component({
  selector: "app-payor-profile",
  templateUrl: "./payor-profile.component.html",
  styleUrls: ["./payor-profile.component.scss"],
  standalone: true,
  imports: [CommonModule, RouterModule, MatTabsModule, MatDialogModule],
  providers: [PayorStore],
})
export class PayorProfileComponent {
  id!: string;
  title!: string;
  payor!: any;

  tabRouteMapping: { route: string; display: string }[] = [
    {
      route: "./settings",
      display: "About",
    },
    {
      route: "./facilities",
      display: "Facilities",
    },
  ];
  corporationId!: any;

  constructor(
    private activatedRoute: ActivatedRoute,
    private corpPayorClient: CorpPayorClient,
    private payorStore: PayorStore,
    private router: Router
  ) {}

  async ngOnInit() {
    const payorId = this.activatedRoute.snapshot.params["payorId"];
    this.corporationId =
      this.activatedRoute.snapshot.queryParamMap.get("corporationId");

    if (payorId === "add") {
      this.title = "Add Payor Plan";
    } else {
      this.payor = await firstValueFrom(this.corpPayorClient.getPayor(payorId));

      this.title = `Edit Payor Plan: ${this.payor.corpPayor.payorname}`;

      const nestedPayorInfo = (this.payor as any).corpPayor;
      this.payor = { ...this.payor, ...nestedPayorInfo };
      delete (this.payor as any).corpPayor;

      this.payorStore.setpayor(this.payor);
    }
  }

  onTabClick(route: string) {
    this.router.navigate([route], {
      relativeTo: this.activatedRoute,
      queryParams: { corporationId: this.corporationId },
    });
  }
}
